import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import useBrain from '../../hooks/brain';
import { useWallet } from '../../wallet-context';
import WalletConnect from '../WalletConnect';

import Button from '../../components/buttons/Button';
import Layout from '../../components/Layout';
import { NFTDetails } from '../../types';
import Card from '../../components/Card';

interface Params {
  ipfshash: string;
  signature: string;
}

const Sign: React.FC = () => {
  const { ipfshash, signature } = useParams<Params>();
  const brain = useBrain();
  const { web3, walletAddress } = useWallet();
  const [nft, setNft] = useState<NFTDetails>();

  useEffect(() => {
    const load = async () => {
      const content = await brain.getIpfsContent(ipfshash);
      setNft(content.data as NFTDetails);
    };

    load();
  }, [ipfshash, web3, walletAddress]);

  const confirm = async () => {
    if (!web3) {
      return;
    }

    const tx = await brain.mint(ipfshash, signature);

    try {
      await web3.eth.sendTransaction({
        ...tx,
        from: walletAddress,
      }, (err: any, result: any) => {
      });
    } catch (err) {
      alert(err);
    }
  };

  if (!walletAddress) {
    return (
      <WalletConnect />
    );
  }

  return (
    <Layout>
      <main>
        <section className='md:container md:mx-auto bg-gray-50'>
          <div className="container my-12 mx-auto px-4 md:px-12">
            <div className="flex flex-wrap -mx-1 lg:-mx-4">
              {nft && (
                <Card description={nft.description} image={nft.image} />
              )}
            </div>
          </div>
        </section>
        <section>
          <div className="text-center hero-content text-neutral-content">
            <Button className="connectWallet" onClick={confirm}>
              Confirm
            </Button>
          </div>
        </section>
      </main>
    </Layout>

  );
};

export default Sign;
